import React, { Component } from 'react';
import { nl2br } from '../../../utils/nl2br';

class ReviewQuestionSwitch extends Component {
  renderText(answer) {
    return (
      <div className="review-detail__comments">
        {nl2br(answer) || 'N/A'}
      </div>
    )
  }

  renderRadio(question, answer, isMultipart = false) {
    if (answer) {
      const selectedAnswer = question.parts.filter(item => answer.parts[item.id])[0];
      return (
        <div className={isMultipart ? "review-detail__comments" : "review-detail__digit"}>
          {selectedAnswer.label}
        </div>
      )
    } else {
      return (
        <div className={isMultipart ? "review-detail__comments" : "review-detail__digit"}>
          N/A
        </div>
      )
    }
  }

  renderSlider(question, answer) {
    return (
      <div className="review-detail__digit">
        {Object.values(answer.parts)[0]}/10
      </div>
    )
  }

  renderPercentage(answer) {
    return (
      <div className="review-detail__digit">
        {Object.values(answer.parts)[0]}%
      </div>
    )
  }

  renderDollars(answer) {
    return (
      <div className="review-detail__digit">
        ${Object.values(answer.parts)[0]}
      </div>
    )
  }

  renderRanking(question, answer) {
    return (
      <ol className="review-detail__ranking">
        {Object.entries(answer.parts)
          .sort(([keyA, valA], [keyB, valB]) => valA - valB)
          .map(([answerId, option]) => (
          <li key={answerId}>{question.parts.find(item => item.id.toString() === answerId).label}</li>
        ))}
      </ol>
    )
  }

  renderMultipart(question, answer) {
    return (
      <div className="review-detail__multipart">
        {question.parts.map(part => (
          <div key={part.id}>
            {part.label &&
              <div className="review-detail__multipart-subhead">
                {part.label}
              </div>
            }
            {part.content &&
              <div className="review-detail__multipart-subhead">
                {part.content}
              </div>
            }
            {(() => {
              switch (part.questionType) {
                case 'short_answer':
                  return this.renderText(answer.parts[part.id]);
                case 'long_answer':
                  return this.renderText(answer.parts[part.id]);
                case 'radio':
                  return this.renderRadio(part, answer.parts[part.id], true);
                default:
                  return null;
              }
            })()}
          </div>
        ))}
      </div>
    )
  }

  render() {
    const {question, answer} = this.props;
    switch (question.questionType) {
      case 'long_answer':
        return this.renderText(Object.values(answer.parts)[0]);
      case 'short_answer':
        return this.renderText(Object.values(answer.parts)[0]);
      case 'ranking':
        return this.renderRanking(question, answer);
      case 'radio':
        return this.renderRadio(question, answer);
      case 'slider':
        return this.renderSlider(question, answer);
      case 'percentage':
        return this.renderPercentage(answer);
      case 'dollars':
        return this.renderDollars(answer);
      case 'multipart':
        return this.renderMultipart(question, answer);
      default:
        return null;
    }
  }
}

export default ReviewQuestionSwitch;



// WEBPACK FOOTER //
// ./src/components/features/review/ReviewQuestionSwitch.js